import { inject, observer } from 'mobx-react';
import { action, computed, observable } from 'mobx';
import * as React from 'react';

import './navbar.css';

import { NavbarProps } from '../../types';

@inject('userStore')
@observer
class Navbar extends React.Component<NavbarProps> {
  @observable private burgerActive: boolean = false;

  public constructor(props: NavbarProps) {
    super(props);
  }

  public render() {
    return (
      <nav className="navbar">
        <div className="container">
          <div className="navbar-brand">
            <a className="navbar-item has-text-weight-bold is-size-4" href="/">
              Mentor<sup className='branding-superscript is-size-6'>InTech</sup>
            </a>

            <a
                aria-expanded="false"
                aria-label="menu"
                className={`navbar-burger has-text-grey-dark ${this.activeClass}`.trim()}
                onClick={this.handleClick}
                role="button"
            >
              <span aria-hidden="true" />
              <span aria-hidden="true" />
              <span aria-hidden="true" />
            </a>
          </div>

          <div id="nav-menu" className={`navbar-menu ${this.activeClass}`.trim()}>
            <div className="navbar-end">
              { this.navbarActions }
            </div>
          </div>
        </div>
      </nav>
    );
  }

  @computed
  private get navbarActions() {
    const { isSignedIn, firstName } = this.props.userStore!;

    if (isSignedIn) {
      return (
        <div className="navbar-item has-dropdown is-hoverable">
          <a className="navbar-link is-size-6" href="/user-info">Hello, {firstName}!</a>
          <div className="navbar-dropdown">
            <a className="navbar-item is-size-6" href="/profile">Profile</a>
            <a className="navbar-item is-size-6" href="/dashboard">Dashboard</a>
            <a className="navbar-item is-size-6" href="/sign-out">Log out</a>
          </div>
        </div>
      );
    } else {
      return (
        <>
            <a className="navbar-item is-size-6" href="/sign-up">Sign up</a>
            <a className="navbar-item is-size-6" href="/sign-in">Log in</a>
        </>
      );
    }
  }

  @computed
  private get activeClass() {
    return this.burgerActive ? 'is-active' : '';
  }

  @action
  private handleClick = () => this.burgerActive = !this.burgerActive;
}

export default Navbar;



// WEBPACK FOOTER //
// ./src/common/navbar/Navbar.tsx